import { useSession } from '../store/session';
import { ALL_MODELS } from '../providers';

export default function ModelSelector() {
  const mode = useSession(s => s.mode);
  const override = useSession(s => s.modelOverride);
  const setOverride = useSession(s => s.setModelOverride);
  const options = ALL_MODELS.filter(m => m.mode === mode);

  return (
    <select
      className="chip"
      style={{ paddingRight: 24 }}
      value={override ?? 'auto'}
      onChange={e => setOverride(e.target.value === 'auto' ? undefined : e.target.value)}
    >
      <option value="auto">auto (director routes)</option>
      {options.map(m => {
        const isSame = m.label.toLowerCase().includes(m.provider.toLowerCase());
        const displayLabel = isSame ? m.label : `${m.provider} · ${m.label}`;
        return (
          <option key={`${m.provider}/${m.id}`} value={m.id}>
            {displayLabel}
          </option>
        );
      })}
    </select>
  );
}
